(function() {
    'use strict';

    angular.module('GorillaBoy.services')
    .factory('SortService', [
        '$rootScope',
        '$translate',
        'AppConstants',
        'localStorageService',
        SortService
    ]);

    function SortService ($rootScope, $translate, AppConstants, localStorageService) {
        var sortService = {};

        // AppConstant bindings
        var viewTypes = AppConstants.ViewTypes;

        var ORDER = {
                ASCENDING: 'ASCENDING',
                DESCENDING: 'DESCENDING'
            },
            SORT_BY = {
                DATE: 'DATE',
                NAME: 'NAME',
                SIZE: 'SIZE',
                TYPE: 'TYPE',
                OWNER: 'OWNER',
                FEEDBACK_REQUEST_TIMESTAMP: 'FEEDBACK_REQUEST_TIMESTAMP',
                FEEDBACK_REQUEST_DEADLINE: 'FEEDBACK_REQUEST_DEADLINE'
            },
            SEARCH_ORDER_BY = {
                ALPHABETICAL: 'ALPHABETICAL',
                DATE: 'DATE',
                RELEVANCE: 'RELEVANCE',
                SIZE: 'SIZE',
                TYPE: 'TYPE',
                // For SearchV2
                NAME: 'NAME',
                MODIFIED_TIMESTAMP: 'MODIFIED_TIMESTAMP',
                CONTENT_TYPE: 'CONTENT_TYPE'
            },
            SORT_OPTIONS = [
                {name: 'RECENCY', text: $translate.instant('TOP_NAV.DATE'), sortBy: SORT_BY.DATE, order: ORDER.DESCENDING},
                {name: 'NAME', text: $translate.instant('TOP_NAV.NAME'), sortBy: SORT_BY.NAME, order: ORDER.ASCENDING},
                {name: 'SIZE', text: $translate.instant('TOP_NAV.SIZE'), sortBy: SORT_BY.SIZE, order: ORDER.DESCENDING},
                {name: 'TYPE', text: $translate.instant('TOP_NAV.TYPE'), sortBy: SORT_BY.TYPE, order: ORDER.ASCENDING},
                {name: 'OWNER', text: $translate.instant('TOP_NAV.OWNER'), sortBy: SORT_BY.OWNER, order: ORDER.ASCENDING},
                {name: 'FEEDBACK_REQUEST_TIMESTAMP', text: $translate.instant('TOP_NAV.REQUEST_DATE'), sortBy: SORT_BY.FEEDBACK_REQUEST_TIMESTAMP, order: ORDER.DESCENDING},
                {name: 'FEEDBACK_REQUEST_DEADLINE', text: $translate.instant('TOP_NAV.DEADLINE'), sortBy: SORT_BY.FEEDBACK_REQUEST_DEADLINE, order: ORDER.ASCENDING}
            ],
            SEARCH_SORT_OPTIONS = [
                {name: 'RECENCY', text: $translate.instant('LEFT_NAV.DATE'), orderBy: SEARCH_ORDER_BY.MODIFIED_TIMESTAMP, order: ORDER.DESCENDING},
                {name: 'NAME', text: $translate.instant('LEFT_NAV.NAME'), orderBy: SEARCH_ORDER_BY.NAME, order: ORDER.ASCENDING},
                {name: 'SIZE', text: $translate.instant('LEFT_NAV.SIZE'), orderBy: SEARCH_ORDER_BY.SIZE, order: ORDER.DESCENDING},
                {name: 'TYPE', text: $translate.instant('LEFT_NAV.TYPE'), orderBy: SEARCH_ORDER_BY.CONTENT_TYPE, order: ORDER.ASCENDING},
                {name: 'RELEVANCE', text: $translate.instant('LEFT_NAV.RELEVANCE'), orderBy: SEARCH_ORDER_BY.RELEVANCE, order:ORDER.DESCENDING}
            ],
            SORT_ORDER = 'wd_sort_order',
            // We store the most recent folder type so we can access the correct sort options when in a document view.
            // This is useful for features like prev/next doc in the document view if we need to figure out which sort
            // options to use from those in localStorage and we don't have as much context as we would in a list view.
            MOST_RECENT_FOLDER_TYPE = null;

        var sortOptions = {
                OWNED: {
                    THUMBNAIL: SORT_OPTIONS[0],
                    LIST: SORT_OPTIONS[0]
                },
                FAVORITES: {
                    THUMBNAIL: SORT_OPTIONS[0],
                    LIST: SORT_OPTIONS[0]
                },
                SHARED: {
                    THUMBNAIL: SORT_OPTIONS[0],
                    LIST: SORT_OPTIONS[0]
                },
                FOLDER: {
                    THUMBNAIL: SORT_OPTIONS[0],
                    LIST: SORT_OPTIONS[0]
                },
                RECENT: {
                    THUMBNAIL: SORT_OPTIONS[0],
                    LIST: SORT_OPTIONS[0]
                },
                AWAITING_FEEDBACK: {
                    THUMBNAIL: SORT_OPTIONS[0],
                    LIST: SORT_OPTIONS[0]
                },
                OUT_FOR_REVIEW: {
                    THUMBNAIL: SORT_OPTIONS[0],
                    LIST: SORT_OPTIONS[0]
                },
                RECYCLE: {
                    THUMBNAIL: SORT_OPTIONS[0],
                    LIST: SORT_OPTIONS[0]
                },
                SEARCH: {
                    THUMBNAIL: SEARCH_SORT_OPTIONS[0],
                    LIST: SEARCH_SORT_OPTIONS[0]
                }
            };

        sortService.CONSTANTS = {
            ORDER: ORDER,
            SORT_BY: SORT_BY,
            SEARCH_ORDER_BY: SEARCH_ORDER_BY
        };

        //set the default sort option values
        setDefaultSortOptions();

        function setDefaultSortOptions () {
            localStorageService.set(SORT_ORDER, sortOptions);
        }

        function validateTypeView (type, viewtype) {
            var validTypes = ['OWNED', 'SHARED', 'FOLDER', 'RECENT', 'AWAITING_FEEDBACK', 'OUT_FOR_REVIEW', 'RECYCLE', 'SEARCH', 'FAVORITES'],
                validViewTypes = ['THUMBNAIL', 'LIST'];
            return ((validTypes.indexOf(type) > -1) && (validViewTypes.indexOf(viewtype) > -1));
        }

        sortService.getOppositeOrder = function (sortOrder) {
            return sortOrder === ORDER.ASCENDING ? ORDER.DESCENDING : ORDER.ASCENDING;
        };

        sortService.getDefaultSortOptions = function (type) {
            switch (type) {
                case viewTypes.AWAITING_FEEDBACK_TYPE:
                case viewTypes.OUT_FOR_REVIEW_TYPE:
                    return SORT_OPTIONS;
                case viewTypes.SEARCH_TYPE:
                    return SEARCH_SORT_OPTIONS;
                case viewTypes.FAVORITES:
                case viewTypes.SHARED_TYPE:
                    return SORT_OPTIONS.slice(0,5);
                case viewTypes.OWN_TYPE:
                case viewTypes.FOLDER_TYPE:
                case viewTypes.RECYCLE_TYPE:
                /* falls through */
                default:
                    return SORT_OPTIONS.slice(0, 4);
            }
        };

        sortService.getSortOption = function (type, viewtype) {
            var wdSortOrderStr = localStorageService.get(SORT_ORDER),
                wdSortOrder;

            if (wdSortOrderStr && validateTypeView(type, viewtype)) {
                if (typeof wdSortOrderStr === 'string') {
                    wdSortOrder = JSON.parse(wdSortOrderStr);
                } else {
                    wdSortOrder = wdSortOrderStr;
                }

                if (wdSortOrder[type]) {
                    //If there exist sort options for this view type use them.
                    return wdSortOrder[type][viewtype];
                } else {
                    //otherwise set the default sort options and continue
                    setDefaultSortOptions();
                    return SORT_OPTIONS[0];
                }
            } else {
                setDefaultSortOptions();
                return SORT_OPTIONS[0];
            }
        };

        sortService.setSortOption = function (type, viewtype, sortOption) {
            var wdSortOrderStr = localStorageService.get(SORT_ORDER),
                wdSortOrder;
            if (wdSortOrderStr && validateTypeView(type, viewtype)) {
                if (typeof wdSortOrderStr === 'string') {
                    wdSortOrder = JSON.parse(wdSortOrderStr);
                } else {
                    wdSortOrder = wdSortOrderStr;
                }
                wdSortOrder[type][viewtype] = sortOption;
                localStorageService.set(SORT_ORDER, wdSortOrder);
            } else {
                setDefaultSortOptions();
            }
        };

        sortService.setType = function (type) {
            MOST_RECENT_FOLDER_TYPE = type;
        };

        sortService.getType = function () {
            return MOST_RECENT_FOLDER_TYPE;
        };

        return sortService;
    }

}());
